import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function generateExcelClient(selectedRows, year) {
  if (!selectedRows || selectedRows.length === 0) {
    console.error('No data to export');
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Tours');

  // Define columns for the Excel sheet
  worksheet.columns = [
    { header: 'Cruise Line', key: 'cruiseLine', width: 20 },
    { header: 'Tour Code', key: 'tourCode', width: 12 },
    { header: 'Tour Name', key: 'tourName', width: 30 },
    { header: 'Min Pax', key: 'paxMin', width: 10 },
    { header: 'Max Pax', key: 'paxMax', width: 10 },
    { header: 'Item', key: 'item', width: 20 },
    { header: 'Type', key: 'type', width: 15 },
    { header: 'Factor', key: 'factor', width: 10 },
    { header: 'Buy Price', key: 'calculatedBuy', width: 15 },
    { header: 'Sell Price', key: 'sellPrice', width: 15 },
    { header: 'Description', key: 'description', width: 50 },
  ];

  // Style header row
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { horizontal: 'center', vertical: 'middle' };

  // Set header background color
  const headerColumns = 'ABCDEFGHIJK'.split('');
  headerColumns.forEach((col) => {
    worksheet.getCell(`${col}1`).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'E2923D' },
    };
  });

  let currentRow = 2;

  // Add data rows
  selectedRows.forEach((row) => {
    const tourDetails = {
      tourCode: row.attributes.tourCode,
      tourName: row.attributes.tourName,
      cruiseLine: row.attributes.cruiseLine,
      description: row.attributes.description || 'N/A',
      paxMin: row.attributes.paxMin || 'N/A',
      paxMax: row.attributes.paxMax || 'N/A',
    };

    const overview = row.attributes.overview || []; // Fetch overview data
    overview.forEach((item, index) => {
      const newRow = worksheet.addRow({
        cruiseLine: index === 0 ? tourDetails.cruiseLine : '',
        tourCode: index === 0 ? tourDetails.tourCode : '',
        tourName: index === 0 ? tourDetails.tourName : '',
        paxMin: index === 0 ? tourDetails.paxMin : '',
        paxMax: index === 0 ? tourDetails.paxMax : '',
        item: item.name || 'N/A',
        type: item.type || 'N/A',
        factor: item.factor || 'N/A',
        calculatedBuy: item.calculatedBuy ? `${item.calculatedBuy} €` : 'N/A',
        sellPrice: item.sellPrice ? `${item.sellPrice} €` : 'N/A',
        description: index === 0 ? tourDetails.description : '',
      });

      // Wrap text in description field
      newRow.getCell('K').alignment = { wrapText: true, vertical: 'top' };
    });

    // Merge cells for the tour details columns across the overview rows
    if (overview.length > 1) {
      worksheet.mergeCells(`A${currentRow}:A${currentRow + overview.length - 1}`); // Cruise Line
      worksheet.mergeCells(`B${currentRow}:B${currentRow + overview.length - 1}`); // Tour Code
      worksheet.mergeCells(`C${currentRow}:C${currentRow + overview.length - 1}`); // Tour Name
      worksheet.mergeCells(`D${currentRow}:D${currentRow + overview.length - 1}`); // Min Pax
      worksheet.mergeCells(`E${currentRow}:E${currentRow + overview.length - 1}`); // Max Pax
      worksheet.mergeCells(`K${currentRow}:K${currentRow + overview.length - 1}`); // Description
    }

    currentRow += overview.length; // Update row counter
  });

  // Style rows and apply borders
  for (let i = 2; i <= worksheet.rowCount; i++) {
    const row = worksheet.getRow(i);
    row.alignment = { horizontal: 'center', vertical: 'middle' };

    // Apply borders to all cells in columns A to K
    for (let j = 1; j <= 11; j++) {
      worksheet.getCell(`${String.fromCharCode(64 + j)}${i}`).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${selectedRows[0].attributes.year}_Cost_Sheet_client_${selectedRows[0].attributes.cruiseLine}.xlsx`);
}
